const INVALID_FILENAME_CHARACTERS = /[/\\:*?"<>|]/g;
// eslint-disable-next-line no-control-regex -- intentionally matching control characters to strip them from filenames
const CONTROL_CHARACTERS = /[\x00-\x1f\x7f]/g;
const WHITESPACE_RUN = /\s+/g;

function sanitizeFilenamePart(part: string): string {
  return part
    .replace(INVALID_FILENAME_CHARACTERS, "")
    .replace(CONTROL_CHARACTERS, "")
    .replace(WHITESPACE_RUN, " ")
    .trim();
}

/**
 * Builds a filename for a generated document PDF attachment (e.g. a quote or
 * requirement PDF) of the form `<Label>-<number>.pdf`, or `<Label>.pdf` when
 * no number is available. Strips characters that are invalid in filenames,
 * collapses whitespace and trims the result before appending the extension.
 */
export function buildPdfAttachmentFilename(
  label: string,
  number?: string | null
): string {
  const sanitizedLabel = sanitizeFilenamePart(label);
  const sanitizedNumber = number ? sanitizeFilenamePart(number) : "";

  const name = sanitizedNumber
    ? `${sanitizedLabel}-${sanitizedNumber}`
    : sanitizedLabel;

  return `${name}.pdf`;
}
